document.addEventListener('input', function (event) {
  if (!event.target.matches('[data-vendor-menu-search]')) return;

  var term = event.target.value.trim().toLowerCase();
  var wrapper = event.target.closest('.menu-row__col, .mm-nav__links-wrapper') || document;
  var list = wrapper.querySelector('[data-vendor-menu-list]');
  var emptyMsg = wrapper.querySelector('[data-vendor-menu-empty]');
  if (!list) return;

  var visibleCount = 0;
  list.querySelectorAll('.menu__item').forEach(function (item) {
    var isMatch = item.textContent.trim().toLowerCase().indexOf(term) !== -1;
    item.hidden = !isMatch;
    if (isMatch) visibleCount++;
  });

  if (emptyMsg) emptyMsg.hidden = visibleCount !== 0;
}, true);
